<template>
    <b-container fluid style="padding-bottom:135px; padding-top:0" class="bg_atos">
        <b-container style="padding-top:80px; margin-bottom:80px">
            <b-row>
                <b-col class="paternTitle">
                    {{$t('tu_title')}}
                </b-col>
            </b-row>
            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">{{$t('tu_paragraph1')}}</p>
                    <p class="patternText">{{$t('tu_paragraph2')}}</p>
                    <p class="patternText">{{$t('tu_paragraph3')}}</p>
                    <p class="patternText">{{$t('tu_paragraph4')}}</p>
                    <p class="patternText">{{$t('tu_paragraph5')}} <br><br></p>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>